export function compareArrays(a: any[], b: any[]): boolean {
    return a.length === b.length && a.every((v, i) => v === b[i]);
}

export function containsArray(a: any, b: any): boolean {
    return a.some((v: any) => compareArrays(v, b));
}
